// Display helpers for the automation list pages (drops, workflows, scheduled messages).
// Labels mirror the wording used in the AutomationNeue editor.

const TRIGGER_LABELS = {
  ReceivedSmsWorkflowTrigger: 'Receive SMS'
}

const ACTION_LABELS = {
  SendSmsWorkflowAction: 'Send SMS',
  SkipDropWorkflowAction: 'Skip Drop',
  AssignTagWorkflowAction: 'Assign Tag',
  GiveAccountCreditWorkflowAction: 'Give Account Credit',
  AssignMembershipTierWorkflowAction: 'Assign Membership Tier'
}

// The editor's action-type dropdown, built from the same labels the list page shows.
export function workflowActionOptions() {
  return Object.entries(ACTION_LABELS).map(([value, name]) => ({ name, value }))
}

// Whether an action has the config it needs before the editor lets the merchant continue.
export function workflowActionIsComplete(action) {
  const config = action.config || {}
  if (action.type === 'AssignMembershipTierWorkflowAction') return !!config.membership_tier_id
  if (action.type === 'AssignTagWorkflowAction') return !!config.tag_text?.trim()
  if (action.type === 'GiveAccountCreditWorkflowAction') return parseFloat(config.amount) > 0
  return !!config.message?.trim()
}

// Saved config as the editor needs it: the tier picker's option values are
// JSONAPI string ids and SelectInput compares strictly, so a numeric id must become a string.
export function workflowActionConfigFromServer(config) {
  if (!config) return {}
  if (config.membership_tier_id === null || config.membership_tier_id === undefined) return config
  return { ...config, membership_tier_id: String(config.membership_tier_id) }
}

// Options for the Assign Membership Tier picker. hasMealPlan lets the editor warn
// that moving a customer onto the tier attempts the first meal plan charge.
export function membershipTierOptions(tiers) {
  return (tiers || [])
    .filter(tier => tier.attributes.is_active)
    .map(tier => ({
      name: tier.attributes.tier_name,
      value: tier.id,
      hasMealPlan: !!tier.relationships?.meal_plan?.data
    }))
}

export function workflowTriggerLabel(type) {
  if (!type) return '-'
  return TRIGGER_LABELS[type] || type
}

export function workflowActionsLabel(actions) {
  if (!actions?.length) return 'No actions'
  return [...actions]
    .sort((a, b) => (a.attributes.order || 0) - (b.attributes.order || 0))
    .map(action => ACTION_LABELS[action.attributes.type] || action.attributes.type)
    .join(', ')
}

export function scheduledMessageTime(scheduler) {
  if (!scheduler?.attributes?.datetime) return 'Not scheduled'
  const { datetime, frequency } = scheduler.attributes
  const when = new Intl.DateTimeFormat([], {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(datetime))
  if (!frequency || frequency === 'once') return when
  return `${when}, repeat ${frequency.replace(/-/g, ' ')}`
}

export function onOffBadge(on, onLabel, offLabel) {
  return on
    ? { label: onLabel, classes: 'bg-green-100 text-green-800' }
    : { label: offLabel, classes: 'bg-gray-100 text-gray-600' }
}
